import { docElectronicoIdFromPublicId, textoMayusEs } from '../infrastructure/foGesrFieldFormattingCore.ts';
import type { PuntoEntregaReportPdfDetail, PuntoEntregaReportPdfParticipante } from './puntoEntregaReportPdfData.ts';

export {
  celdaDocumentoYTipo,
  comunaOCorregimientoPdf,
  formatFechaPdf,
  formatHora12,
  siNo,
  splitFechaHora,
  textoMayusEs,
  tipoBonoCeldaPdf,
} from '../infrastructure/foGesrFieldFormattingCore.ts';

/** Table headers — same titles and line breaks as FO-GESR-2160 in the PDF. */
export const TABLA_ENCABEZADOS: string[] = [
  'NÚMERO DE\nBONO',
  'TIPO DE BONO',
  'DOCUMENTO Y TIPO',
  'NOMBRE\nPARTICIPANTE',
  'PERSONA\nAUTORIZADA',
  'DOCUMENTOS PERSONA\nAUTORIZADA',
  '¿AUTORIZA POLÍTICA\nDE PRIVACIDAD?',
  'REGISTRO\nFOTOGRÁFICO DE\nENTREGA',
  'FIRMA',
  '¿EL PARTICIPANTE\nASISTE A ENCUENTRO\nEDUCATIVO?',
  '¿SE ENTREGA ACTA\nDE COMPROMISO?',
  '¿SE ENTREGA\nBOLSA\nREUTILIZABLE?',
];

export const COL_WIDTHS_MM = [14, 28, 24, 32, 22, 24, 18, 20, 14, 22, 18, 18];
/** Delivery number for PDF. */


export function numeroEntregaPdf(detail: PuntoEntregaReportPdfDetail, entregaNombre: string): string {
  const s = `${detail.entregaId || ''} ${entregaNombre || ''}`.trim();
  const nums = s.match(/\d+/g);
  if (nums?.length) return nums.at(-1) ?? '—';
  return s || '—';
}
/** Commitment act delivered flag. */


export function actaCompromisoEntregada(acta: string): boolean {
  const t = acta.trim().toLowerCase();
  if (t === 'no' || t === 'n') return false;
  if (t === 'sí' || t === 'si' || t === 's') return true;
  return t.length > 0;
}

/** Name only in the «PERSONA AUTORIZADA» cell (images are drawn separately in that column). */
export function celdaNombrePersonaAutorizada(p: PuntoEntregaReportPdfParticipante): string {
  if (!p.presentaAcudienteAutorizado) return 'NO';
  const n = p.acudiente?.nombre?.trim();
  return n && n.length > 0 ? textoMayusEs(n) : '—';
}

/** Order of guardian images under the name (same sequence as in the delivery-record form). */
export function acudienteImagenesOrdenPdf(p: PuntoEntregaReportPdfParticipante): string[] {
  if (!p.presentaAcudienteAutorizado || !p.acudiente) return [];
  const a = p.acudiente;
  const keys = [
    'documentoFrontal',
    'documentoReverso',
    'documentoAutorizadoFrontal',
    'documentoAutorizadoReverso',
    'autorizado',
  ] as const;
  const out: string[] = [];
  for (const k of keys) {
    const s = a[k];
    const t = String(s ?? '').trim();
    if (t !== '') out.push(t);
  }
  return out;
}
/** Doc electronico id. */


export function docElectronicoId(detail: PuntoEntregaReportPdfDetail): string {
  return docElectronicoIdFromPublicId(detail.publicId);
}
/** Ubicacion pdf. */


export function ubicacionPdf(detail: PuntoEntregaReportPdfDetail): string {
  const parts: string[] = [];
  const dir = (detail.direccion ?? '').trim();
  const lat = (detail.latitud ?? '').trim();
  const lon = (detail.longitud ?? '').trim();
  if (dir) parts.push(dir);
  if (lat || lon) parts.push([lat, lon].filter(Boolean).join(', '));
  return parts.length ? parts.join('\n') : '';
}
